import { defineMessages } from 'react-intl'

export default defineMessages({
  changeTaskType: {
    id: 'containers.OrderPage.components.TaskPage.components.ChangeTaskType.changeTaskType',
    defaultMessage: 'Change task type',
  }
})